import AsyncStorage from '@react-native-async-storage/async-storage';
import createApolloClient from '../common/graphql/apolloClient';
import { getServerEndpoint } from './utils';

export default createApolloClient({
	getToken: () => {
		return AsyncStorage.getItem('token');
	},
	// cacheStorage: AsyncStorage,
	getApiHost: async () => `${await getServerEndpoint()}/api`,
	getwsHost: async () => `${await getServerEndpoint(true)}/subscriptions`,
}).then(client => {
	client.cache.policies.addTypePolicies({
		ServiceDocket: {
			fields: {
				// Product changes need embedded per-stop items even when visits share a PickList.
				pickList: { keyArgs: ['@connection', ['key']] },
			},
		},
	});
	return client;
});
